import type {
  DialogueLogCreateRequest,
  DialogueLogPatchRequest,
} from '@shared/types/dialogue-log';

export interface ValidationIssue {
  field: keyof DialogueLogCreateRequest | 'form';
  message: string;
}

const ALLOWED_TYPES = ['phone', 'online_mtg', 'in_person', 'email', 'other'];

/// 作成/編集フォームで共通の検証対象フィールド。 編集 (full-form patch) でも
/// `DialogueLogPatchRequest` の optional 性に引きずられず、 作成時と同じ
/// 必須条件を要求する (dialogue-log-edit 仕様 Validation Rules)。
type DialogueLogFormFields = Pick<
  DialogueLogPatchRequest,
  'type' | 'occurred_at' | 'title' | 'participant_lawyer_ids'
>;

function validateCommonFields(input: DialogueLogFormFields): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  if (!input.occurred_at || input.occurred_at.trim().length === 0) {
    issues.push({ field: 'occurred_at', message: '日時を指定してください' });
  }
  if (!input.type || !ALLOWED_TYPES.includes(input.type)) {
    issues.push({ field: 'type', message: '対話方法を選択してください' });
  }
  if (!input.title || input.title.trim().length === 0) {
    issues.push({ field: 'title', message: 'タイトルは必須です' });
  }
  // timeline.md §5.2: 顧客側参加者は必須。
  if (!input.participant_lawyer_ids || input.participant_lawyer_ids.length === 0) {
    issues.push({
      field: 'participant_lawyer_ids',
      message: '顧客側参加者 (弁護士) を最低 1 名選択してください',
    });
  }
  return issues;
}

export function validateDialogueLogCreate(
  input: DialogueLogCreateRequest,
): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  if (!input.firm_id || input.firm_id.trim().length === 0) {
    issues.push({ field: 'firm_id', message: '対象事務所が必要です' });
  }
  issues.push(...validateCommonFields(input));
  return issues;
}

/// 既存エントリ編集 (PATCH) の検証。 firm_id は不変のため検証対象外。
export function validateDialogueLogEdit(
  input: DialogueLogFormFields,
): ValidationIssue[] {
  return validateCommonFields(input);
}
